// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Header__container___zJ4iV {
    padding: 0px 6vw;
    z-index: 20002;
}

.Header__titleText___INQaC {
    font-family: 'IM Fell French Canon SC', serif;
    margin: 4px 0px;
    font-size: 20px;
    transition: color 1s;
}

.Header__notMetDailyTarget___p4VUJ {
    text-shadow: 0px 1px 5px #4c4c4c;
}

.Header__gradient___s4iTI {
    height: 80px;
    border: none;
}

.Header__gradient_normal___Slp_O {
    background: linear-gradient(rgba(40, 40, 40, 1), rgba(0, 0, 0, 0));
}

.Header__gradient_gold___qHvEi {
    background: linear-gradient(rgba(64, 57, 31, 0.9), rgba(0, 0, 0, 0));
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Header__container___zJ4iV`,
	"titleText": `Header__titleText___INQaC`,
	"notMetDailyTarget": `Header__notMetDailyTarget___p4VUJ`,
	"gradient": `Header__gradient___s4iTI`,
	"gradient_normal": `Header__gradient_normal___Slp_O`,
	"gradient_gold": `Header__gradient_gold___qHvEi`
};
module.exports = ___CSS_LOADER_EXPORT___;
